import {Component, EventEmitter, OnDestroy, Output, ChangeDetectionStrategy} from '@angular/core';
import {FaIconComponent} from '@fortawesome/angular-fontawesome';
import {faCheck, faClipboardCheck, faCopy} from '@fortawesome/pro-solid-svg-icons';
import {TooltipDirective} from '@buildinginformationcloud/bic-ui-components';

/**
 * Kopieren-/Aufgabe-erstellen-Icons einer Berichtszeile (KI-Bericht, myCheck-Bericht, IDS-Bericht -
 * überall identisch). Ein Ort statt bisher 6 Kopien, die sonst bei jeder Anpassung auseinanderlaufen.
 *
 * Nebeneinander statt untereinander: zwei Icons in einer Spalte änderten sonst die Kartenhöhe
 * gegenüber einzeiligen Karten.
 */
@Component({
  selector: 'app-report-row-actions',
  standalone: true,
  imports: [FaIconComponent, TooltipDirective],
  templateUrl: './report-row-actions.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrls: ['./report-row-actions.component.scss'],
})
export class ReportRowActionsComponent implements OnDestroy {
  @Output() copyClick = new EventEmitter<void>();
  @Output() taskClick = new EventEmitter<void>();

  protected readonly faCopy = faCopy;
  protected readonly faCheck = faCheck;
  protected readonly faClipboardCheck = faClipboardCheck;

  /** Kurzzeitig true nach dem Klick, für Icon-Wechsel + Tooltip-Text als Kopier-Feedback. */
  copied = false;
  private copiedTimeout?: ReturnType<typeof setTimeout>;

  onCopyClick(event: MouseEvent): void {
    // stopPropagation zentral hier statt an jeder der 6 Einbindungen: die Buttons sitzen in
    // klickbaren Zeilen (Zeilenauswahl), ein Klick aufs Icon darf die Zeile nicht mitauswählen.
    event.stopPropagation();
    this.copyClick.emit();

    this.copied = true;
    clearTimeout(this.copiedTimeout);
    this.copiedTimeout = setTimeout(() => this.copied = false, 800);
  }

  onTaskClick(event: MouseEvent): void {
    event.stopPropagation();
    this.taskClick.emit();
  }

  ngOnDestroy(): void {
    clearTimeout(this.copiedTimeout);
  }
}
